import privacyPolicyModule from "@/store/Documents/types/privacyPolicyModule";
import http from "@/utils/service/http.js";

let state = {
    existingDocuments: []
};

let getters = {
    getExistingDocumentByType: state => searchedType => {
        return state.existingDocuments.filter(
            ({ type }) => type === searchedType
        );
    }
};

let mutations = {
    SET_EXISTING_DOCUMENTS(state, data) {
        state.existingDocuments = data;
    }
};

let actions = {
    async getExistingDocuments({ commit }) {
        let existingDocuments = await http.get("/api/v1/documents");

        commit("SET_EXISTING_DOCUMENTS", existingDocuments);

        return existingDocuments;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        privacyPolicy: privacyPolicyModule
    }
};
